/**
 * @generated SignedSource<<bb8537bc46b8a5e44874150126d26f93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AcceptTerms_Query$variables = {};
export type AcceptTerms_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"AcceptTerms_viewer">;
  } | null;
};
export type AcceptTerms_Query = {
  variables: AcceptTerms_Query$variables;
  response: AcceptTerms_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "accept_terms"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"accept_terms\")"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AcceptTerms_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AcceptTerms_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AcceptTerms_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAcceptedTerms",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7d18161b825bcd1cbc2d8717d9899c3b",
    "id": null,
    "metadata": {},
    "name": "AcceptTerms_Query",
    "operationKind": "query",
    "text": "query AcceptTerms_Query {\n  viewer {\n    actualPersonId\n    component(name: \"accept_terms\")\n    ...AcceptTerms_viewer\n    id\n  }\n}\n\nfragment AcceptTerms_viewer on Viewer {\n  id\n  actualPersonId\n  hasAcceptedTerms\n}\n"
  }
};
})();

(node as any).hash = "0f31ecd43760cf011b537f7427fe7791";

export default node;
